import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

import { useCallback } from "react"
import { Row } from "style/preset"

import { ReactComponent as BorderRightCircleSvg } from 'assets/svgs/border_right_circle.svg'
import { ReactComponent as MediumSvg } from 'assets/svgs/medium_icon.svg'

interface BorderBtnProps {
    showIcon?: boolean
    label: string,
    iconIndex: string
    onClick?: () => void
    type?: string
}
const BorderBtnCom = ({label, iconIndex, showIcon = false, type = 'normal', onClick = () => {}}: BorderBtnProps) => {
    const getIconNode = useCallback(() => {
        switch(iconIndex) {
            case '1':
                return <BorderRightCircleSvgWrap></BorderRightCircleSvgWrap>
            case '2':
                return <MediumSvgWrap></MediumSvgWrap>
        }
    }, [iconIndex])

    return <BorderBtnWrap onClick={onClick} $type={type}>
        {showIcon && getIconNode()}
        <BtnLabelWrap>{label}</BtnLabelWrap>
    </BorderBtnWrap>
}

// svg 图标
const svgStyle = () => {
    return css`
        width: 16px;
        height: 16px;
        margin-right: 10px;
        rect, path {
            transition: all 0.2s;
        }
    `
}

const BorderRightCircleSvgWrap = styled(BorderRightCircleSvg)`
    ${svgStyle()}
`
const MediumSvgWrap = styled(MediumSvg)`
    ${svgStyle()}
`

const BtnLabelWrap = styled(StyledContainer)`
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;
    font-family: RoobertSemiBold;
    color: #4D1DF7;
`

const BorderBtnWrap = styled(Row)<{$type: string}>`
    padding: 10px 16px;
    border: 1px solid #4D1DF7;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
        background-color: #4D1DF7;
        ${BtnLabelWrap} {
            color: #ffffff;
        }
        ${BorderRightCircleSvgWrap} {
            rect, path {
                fill: #ffffff;
            }
        }
    }


    ${
        ({$type}) => $type === 'normal' ? css``:css`
            border-color: #A0A3A7;
            ${BtnLabelWrap} {
                color: #A0A3A7;
            }
            ${MediumSvgWrap} {
                rect, path {
                    fill: #A0A3A7;
                }
            }

            &:hover {
                background-color: #0a0a0a;
                border-color: #0a0a0a;
                ${BtnLabelWrap} {
                    color: #ffffff;
                }
                ${MediumSvgWrap} {
                    rect, path {
                        fill: #ffffff;
                    }
                }
            }
        `
    }
`

export default BorderBtnCom